import { Form, Input } from "antd";
import { Button } from "Components/General/Button";
import { ModalComponentProps } from "Components/General/Modal/ModalContext";
import { I18N_NS } from "Config/i18n";
import { useTranslation } from "react-i18next";

interface ChangeFileDescriptionProps extends ModalComponentProps {
  onSubmit: (description: string) => void;
}

export const ChangeFileDescription = ({ onSubmit, hideModal }: ChangeFileDescriptionProps) => {
  const { t } = useTranslation(I18N_NS.PROJECT);

  const handleFinish = (values) => {
    onSubmit(values.description);
    hideModal();
  };

  return (
    <Form onFinish={handleFinish} requiredMark={false}>
      <Form.Item name="description" rules={[{ required: true, message: t("This field is required") }]}>
        <Input placeholder={t("New description")} />
      </Form.Item>
      <div className="text-right">
        <Button htmlType="submit" type="primary">
          OK
        </Button>
      </div>
    </Form>
  );
};
